import { takeEvery, call } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'
import { AxiosError } from 'axios'

import {
  BulkUpdateResponse,
  NewAddressObject,
  RecordBulkUpdateAction,
  RECORD_BULK_UPDATE
} from './actions'
import { handleApiFailure } from 'portal/lib/sharedComponents/apiFailureHandler'

function* editRecordBulkUpdateSaga(action: RecordBulkUpdateAction) {
  const {
    accountId,
    projectId,
    moduleName,
    fieldName,
    newValue,
    recordIds,
    showSuccessNotification,
    showFailureNotification,
    allowOverwrite = false
  } = action

  const isAddressField = fieldName.toLowerCase().includes('address')
  const endpoint = isAddressField
    ? `/accounts/${accountId}/projects/${projectId}/bulk-update/address`
    : `/accounts/${accountId}/projects/${projectId}/modules/${moduleName}/bulk-update`

  const isNewAddressObject = (value: unknown): value is NewAddressObject => {
    return (
      typeof value === 'object' &&
      value !== null &&
      'newAddressEntered' in value &&
      'newAddressKnown' in value &&
      'newAddressCoordinates' in value
    )
  }

  const requestBody = isNewAddressObject(newValue)
    ? { fieldName, ...newValue, recordIds, allowOverwrite }
    : { fieldName, newValue, recordIds, allowOverwrite }

  try {
    yield call(() =>
      axios
        .put<BulkUpdateResponse>(endpoint, requestBody, {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              return true
            }
            return false
          }
        })
        .then(response => {
          const {
            isFullySuccessful,
            recordsRequested,
            recordsSuccessfullyUpdated,
            failures
          } = response.data

          if (isFullySuccessful) {
            showSuccessNotification({
              isFullySuccessful,
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
          } else {
            console.warn('Partial bulk update failure:', {
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
            showSuccessNotification({
              isFullySuccessful,
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
          }
        })
    )
  } catch (error) {
    console.error('Error bulk update of records:', error)
    if (error instanceof AxiosError) {
      handleApiFailure(error)
    } else {
      showFailureNotification()
    }
  }
}

export function* watch() {
  yield takeEvery(RECORD_BULK_UPDATE, editRecordBulkUpdateSaga)
}
